<h3 style="text-align: left; margin-bottom: 20px;">
    <strong>Search & Select Project</strong>
</h3>

<nz-select nzPlaceHolder="Select Project" nzAllowClear nzShowSearch nzServerSearch
    [(ngModel)]="selectedProject" (nzOnSearch)="onSearch($event)" [nzDisabled]="modalData?.id">
    @if (!loading) {
        @for (o of optionList; track o.id) {
            <nz-option [nzValue]="o.id" [nzLabel]="o.name"></nz-option>
        }
    } @else {
    <nz-option nzDisabled nzCustomContent>
        <nz-icon nzType="loading" class="loading-icon" />
        Loading Data...
    </nz-option>
    }
</nz-select>



<button nz-button nzType="primary" (click)="create()" [disabled]="!selectedProject"
 style="width: 100%; margin-top: 20px;">
    Create
</button>